// extracted by mini-css-extract-plugin
module.exports = {"item":"ResultItem_item__72tvi","detail":"ResultItem_detail__1nfaH","name":"ResultItem_name__3eTB5","date":"ResultItem_date__iBh2w","view":"ResultItem_view__2OV50"};